<div fxFlex="0 0 100%" fxLayout="column" fxLayoutAlign="start center">
    <app-sticky-header
        class="sticky-header"
        [title]="getTabTitle()"
        context="Custom Tab"
        contextIcon="speed"
        [showSubmit]="form.valid"
        (onSubmit)="onSubmit()"
        (onCancel)="onCancel()"
    ></app-sticky-header>
    <div [formGroup]="form" class="data-wrap" fxLayout="column" fxLayoutGap="2em">
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between start">
            <div fxLayout="column" fxLayoutGap="4px">
                <span class="label-name" i18n="@@name">Name*</span>
                <app-title-translation
                    type="title"
                    [borderedStyle]="true"
                    i18n-placeholder
                    placeholder="Enter dashboard tab name"
                    formControlName="name"
                    class="name-input"
                ></app-title-translation>
            </div>

            <app-user-setting-input
                [numbersCounterChanger]="true"
                type="number"
                i18n-placeholder
                placeholder="Enter dashboard tab order"
                [control]="form.get('order') | cast"
            >
                <label role="input-label" i18n="@@order">Order</label>
            </app-user-setting-input>
            <app-user-setting-input class="active-switch" type="switch" [control]="form.get('enabled') | cast">
                <span class="label" role="switch-label">
                    <ng-container i18n="active">Active</ng-container>
                </span>
            </app-user-setting-input>
        </div>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
            <app-user-setting-input
                type="dropdown"
                [control]="form.get('context') | cast"
                [selectOptions]="contextOptions"
                placeholder="Select scope"
                class="context-dropdown"
            >
                <span class="label" role="select-title" i18n="@@results_scope"> Results scope </span>
            </app-user-setting-input>
            <!-- Don't show if user platform or public -->
            <ng-container
                *ngIf="!data.isUserPlatform && data.customTab && data.customTab?.privacy !== CustomTabPrivacy.PUBLIC"
            >
                <mat-checkbox [formControl]="form.get('required') | cast" color="primary" class="draft-checkbox">
                    <span i18n>Should appear in all learners' dashboards</span>
                </mat-checkbox>
            </ng-container>
        </div>

        <app-custom-tabs-editor-filters
            [disabled]="hideFilters"
            [customer]="customer$ | async"
            [appliedFilters]="getAppliedUXFilters(data.customTab?.metadata?.filters || [])"
            (appliedFiltersChange)="appliedFilters = $event"
        ></app-custom-tabs-editor-filters>
    </div>
</div>
